import React, { useEffect } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import './About.css';

const About: React.FC = () => {
  const { t } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="hero-content">
          <div className="hero-badge">{t.about.badge}</div>
          <h1 className="hero-title">
            <span className="gradient-text">{t.about.hero_title1}</span>{' '}
            <span>{t.about.hero_title2}</span>
          </h1>
          <p className="hero-subtitle">{t.about.subtitle}</p>
        </div>
      </section>

      <div className="about-content">
        <div className="section-block">
          <div className="section-label">{t.about.overview_label}</div>
          <h2>
            <span>{t.about.title1}</span>{' '}
            <span className="gradient-text">{t.about.title2}</span>{' '}
            <span>{t.about.title3}</span>
          </h2>
          <p>{t.about.p1}</p>
          <p>{t.about.p2}</p>
        </div>

        <div className="divider"></div>

        <div className="section-block">
          <div className="section-label">{t.about.ecosystem_label}</div>
          <h2>
            <span>{t.about.ecosystem_title1}</span>{' '}
            <span className="gradient-text">{t.about.ecosystem_title2}</span>
          </h2>
          <p>{t.about.ecosystem_desc}</p>
        </div>

        <div className="divider"></div>

        <div className="section-block">
          <div className="section-label">{t.about.vision_label}</div>
          <h2>
            <span>{t.about.vision_title1}</span>{' '}
            <span className="gradient-text">{t.about.vision_title2}</span>
          </h2>
          <p>{t.about.vision_desc}</p>
        </div>

        <div className="divider"></div>

        <div className="section-block">
          <div className="section-label">{t.about.web3_label}</div>
          <h2>
            <span className="gradient-text">{t.about.web3_title}</span>
          </h2>
          <p>{t.about.web3_desc}</p>
        </div>

        <div className="highlight-card">
          <h3>{t.about.sdk_title}</h3>
          <p>{t.about.sdk_desc}</p>
        </div>

        <div className="divider"></div>

        <div className="section-block">
          <div className="section-label">{t.about.biz_label}</div>
          <h2>
            <span>{t.about.biz_title1}</span>{' '}
            <span className="gradient-text">{t.about.biz_title2}</span>
          </h2>
          <p>{t.about.biz_desc}</p>
        </div>

        <div className="divider"></div>

        <div className="section-block">
          <div className="vision-card">
            <h3>{t.about.mission_title}</h3>
            <p>{t.about.mission_desc}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
